export default __webpack_public_path__ + "static/media/ThirdView.54516a69.jpg";